import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../data.service';
import { UrlConstant } from '../../constants/url-constant';
import { GlobalConstant } from '../../constants/global-constant';
import { CommonService } from '../../services/common.service';
import { AppData } from '../../constants/app-data';
import { NotificationService } from "../../services/notification.service";

// Reference: Localstorage => https://alligator.io/js/introduction-localstorage-sessionstorage/

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  purposeOfUse: string;
  showPurposeOfUseInfo: String;
  
  formDataInvalid = false;
  //contactArray = [];
  message = "";
  resetData: any;
  //form: FormGroup;
  public loginInvalid: boolean;
  public formSubmitAttempt: boolean = false;
  private returnUrl: string;
  
  public competitionSubjectMapping : any; //= [];

  
  trialEntSignup = new FormGroup({
    id: new FormControl(''),
    name: new FormControl(''),
//    subName: new FormControl(''),
//    nickName: new FormControl(''),
//    registrationNo: new FormControl(''),
    affiliatedBy: new FormGroup({
      id: new FormControl(''),
      value: new FormControl('')
    }),
    educationalSystemTypeStr: new FormControl(''),
    address: new FormGroup({
      id: new FormControl(''),
      addressLine1: new FormControl(''),
      addressLine2: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      country: new FormControl(''),
      pinCode: new FormControl('')
    }),
    owner: new FormGroup({
      id: new FormControl(''),
      firstName: new FormControl(''),
      middleName: new FormControl(''),
      lastName: new FormControl(''),
      individualTypeStr: new FormControl(''),
      loginUserId: new FormControl('', [ Validators.minLength(6),  Validators.pattern(GlobalConstant.patternEmail) ]),
	  //roleList: new FormControl('')
    })
  });
  


	trialIndvSignup = new FormGroup({
	    id: new FormControl(''),
	    loginUserId: new FormControl('', [ Validators.minLength(6),  Validators.pattern(GlobalConstant.patternEmail) ]),
	    phoneNumber: new FormControl('', [ Validators.minLength(10),  Validators.maxLength(10) ]),
	    firstName: new FormControl(''),
	    middleName: new FormControl(''),
	    lastName: new FormControl(''),
	    individualTypeStr: new FormControl(''),
	    status: new FormControl(''),
	    createdForCompany: new FormControl(''),
	    contactList: new FormArray([]),
	    compSubMapId: new FormControl('')
	  });
  
  constructor(private fb: FormBuilder,
    private formModule: ReactiveFormsModule,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
    public appData: AppData,
    private dataService: DataService,
    public notificationService: NotificationService
    ) { }
    
    specialId = "";
    extractedCompanyId = -1;
  ngOnInit(): void {
  		let _indvData = this.prepareBlankIndvData(1);
  	
  		var sId = this.route.snapshot.params[GlobalConstant.KEY_URL_PARAM_VENDOR_UNIQUE_ID];
	    //console.log('sid:'+sId + '     this.specialId:'+this.specialId );
	    if(sId==null ||  sId==undefined || sId==''){
			sId = this.dataService.getFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID);
    	}
    
	  if(sId!=null && sId!=undefined && sId!=''){
		  this.specialId = sId;
		  this.extractedCompanyId = this.commonService.extractEnterpriseIdFromUniqueId(sId);
		  _indvData = this.prepareBlankIndvData(this.extractedCompanyId);
		  this.prapareBlankContactList(_indvData, "PHONE");
	  }
	
	
	if(this.appData.individualTypes === undefined)
		this.commonService.prepareIndividualTypes();
	if(this.appData.contactTypes === undefined)
		this.commonService.prepareContactTypes();
	
  	if(this.appData.companyTypes === undefined)
		this.commonService.prepareCompanyTypes();
  	
  	this.retrieveCompSubMapping();
    
	this.indvContactArray.push(this.getSingleContact());
	if(sId!=undefined && sId!='')
		this.indvContactArray.push(this.getSingleContact());
	this.trialIndvSignup.patchValue(_indvData);
	
	let _entData = this.prepareBlankEntData();
	this.trialEntSignup.patchValue(_entData);
  }

    retrieveCompSubMapping(){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : 'Trial'};
    //Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCompSubTypeListTrial, body).subscribe((res: any)=>{
      //console.log(res);
      /**
	   * "list": [
            {"pageNumber": null,"recordsPerPage": null,"baseData": null,
                "sortOrderList": null,"createdDate": null,"updatedDate": null,
                "id": 1,"competitionType": "General_Competition","competitionTypeDesc": "General Competition",
                "subjectType": "Math","subjectTypeDesc": "Mathematics","noOfQuestion": 5,
                "marksCorrectAnswer": 1.0,"marksWrongAnswer": 0.0,"marksSkipAnswer": 0.0
            },
            {
                "pageNumber": null,"recordsPerPage": null,"baseData": null,
                "sortOrderList": null,"createdDate": null,"updatedDate": null,
                "id": 2,"competitionType": "General_Competition",
                "competitionTypeDesc": "General Competition",
                "subjectType": "Resigning","subjectTypeDesc": "Resigning",
                "noOfQuestion": 5,"marksCorrectAnswer": 1.0,
                "marksWrongAnswer": 0.0,"marksSkipAnswer": 0.0
            }
	   ]
	   */
      if(res.data != undefined && res.data.list != undefined && res.data.list.length > 0){
        this.competitionSubjectMapping = res.data.list;
        //console.log(this.competitionSubjectMapping);
      }
      
    });
  }
  
  //Below method is used in html files as well. otherwise html gives error
  get indvContactArray(){
  	return this.trialIndvSignup.controls.contactList as FormArray;
  }	

  onSubmit() {
  	let form;
  	let reqBody;
  	
	if(this.purposeOfUse === 'techHire'){
		reqBody = this.trialEntSignup.value;
		form = this.trialEntSignup;
	} else if(this.purposeOfUse === 'practice' || this.specialId.length>0){
		reqBody = {'owner': this.trialIndvSignup.value};
		reqBody.owner.contactList[0].contactDetail = reqBody.owner.loginUserId; //Email
		if(this.specialId.length>0){
			reqBody.owner.contactList[1].contactDetail = reqBody.owner.phoneNumber; //Phone
			reqBody.id = this.extractedCompanyId;
		}
		form = this.trialIndvSignup;
		
	} else {
	
	}
  
  
  
  	this.loginInvalid = false;
    this.appData.loginInvalid.next(false);
    this.formSubmitAttempt = false;
    if (form.valid) {
      try {
      	let url = UrlConstant.apiSignup;
      	if(this.specialId.length>0)
      		url = UrlConstant.apiSignupZed;
      	let msg = "";
	     // console.log(reqBody);
	 	  this.dataService.sendPostRequestWithBody(url ,reqBody).subscribe((data: any)=>{
	 		//console.log(data);
	 		  
		      if("SUCCESS" === data.status){
		      	//console.log("success code");
		      	this.updateUIData(data.data);
		      	if(this.purposeOfUse === 'techHire'){
		      		msg = "Tech-hire detail Created Successfully. ";
		      	} else if(this.purposeOfUse === 'practice'){
		      		msg = "Practice user Created Successfully. ";
		      		this.addIndivCompSubMapping(reqBody.owner.compSubMapId, reqBody.owner.loginUserId);
		      	} else if(this.specialId.length>0){
					msg = "Welcome to Zed system.";
		      		this.addIndivCompSubMapping(reqBody.owner.compSubMapId, reqBody.owner.loginUserId);
				}
		      	this.message = data.message; //"Data Updated Successfully";
		      	//this.notificationService.success(msg + data.message);
		      	this.notificationService.openSnackBar(msg + data.message, 'Close', 'green-snackbar', 0);
	      		//this.router.navigate(['/dashboard', { 'userId': '' }]);
		      } else {
		      //  console.log("Signup Failed. Please re-try");
	      		//this.message = "Signup Failed. Please re-try";
	      		this.notificationService.error(data.message);
	      		//this.router.navigate(['/dashboard', { 'userId': username }]);
		      }
		      
		  });
	    
      } catch (err) {
        console.log(err);
      }
    } else {
      this.formSubmitAttempt = true;
    }
  }
  
    addIndivCompSubMapping(csmid, loginUserId){
	  	let body = this.getDefaultCompSubMappingData();
	  	body.loginUserId = loginUserId;
	  	this.competitionSubjectMapping.forEach(data=>{
			  if(data.id === csmid){
				  body.noOfQuestionsToAttempt = data.noOfQuestion;
			  	  body.marksCorrectAnswer = data.marksCorrectAnswer;
			  	  body.marksWrongAnswer = data.marksWrongAnswer;
			  	  body.marksSkipAnswer = data.marksSkipAnswer;
			  	  body.compSubMappingList.push(data);
			  }
		  });
	  	
	    
	    //Creation of Individual's Competition Subject Mapping List
	    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCreateCompSubMappingList, body).subscribe((res: any)=>{
	      //console.log(res);
	      //this.retrieveIndivCompSubMapping(this.loginUserByParam);
	    });
  }
  
  getDefaultCompSubMappingData(){
  	return {"id": null, "compSubMappingList" : [], loginUserId: '', 
  			noOfQuestionsToAttempt: 0, marksCorrectAnswer:1.0, marksWrongAnswer:0.0, marksSkipAnswer:0.0,
  			 baseData: 'Single' };
  }
  updateUIData(dataObject){
  
  	if(this.purposeOfUse === 'techHire'){
		dataObject.educationalSystemTypeStr = dataObject.educationalSystemType;
	  	dataObject.owner.individualTypeStr = dataObject.owner.individualType;
	  	this.trialEntSignup.patchValue(dataObject);
	} else if(this.purposeOfUse === 'practice'){
		dataObject.individualTypeStr = dataObject.individualType;
		this.trialIndvSignup.patchValue(dataObject);
	} else {
	
	}
  
  	
  }
  
  public async sendLoginRequest(username:string, password:string){
  	var reqBody = {"userId":username, "password":password};
  	await this.dataService.sendPostRequestWithBody(UrlConstant.apiLogin ,reqBody).toPromise().then((data: any)=>{
	     // console.log(data);
	      this.message = data;
	      if("SUCCESS" === data.statusCode){
	      //	console.log("success code");
	      	if(data.loginUserStatus === "FORCE-PASSWORD-CHANGE"){
	      		this.router.navigate(['/changePassword', { 'userId': username, 'token': data.token, 'loginUserStatus': 'FORCE-PASSWORD-CHANGE' }]);
	      		return;
	      	}
	      	this.loginInvalid = false;
	      	this.appData.loginInvalid.next(false);
      		this.appData.isAuthenticated.next(true);
      		this.appData.userId = username;
      		this.appData.loginSuccessToken = data.token;
      		
      		if (window.localStorage) {
			 // console.log('localStorage supported');
			  this.dataService.setApiKeyHeaderToLocalStorage(data.token);
			}
			
			//this.dataService.getLoggedInUserData({"userId": username });
			this.dataService.getLoggedInUserDataWithAllPrivileges({"userId": username });
			
      		this.router.navigate(['/dashboard', { 'userId': username }]);
	      } else {
      		this.loginInvalid = true;
      		this.appData.loginInvalid.next(true);
      		this.appData.isAuthenticated.next(false);
      		//this.router.navigate(['/dashboard', { 'userId': username }]);
	      }
	    });
  }

	prepareBlankEntData(){
		return {
		    id: '',
		    name: '',
		  //  subName: '',
		  //  nickName: '',
		  //  registrationNo: '',
		    affiliatedBy:  {
		      id: '',
		      value:''
		    },
		    educationalSystemTypeStr: 'SELF',
		    address: {
		      addressLine1: '',
		      addressLine2: '',
		      city: '',
		      state: '',
		      country: '',
		      pinCode: ''
		    },
		    
		    owner: {
		      id: '',
		      firstName: '',
		      middleName: '',
		      lastName: '',
		      individualTypeStr: 'OWNER',
		      loginUserId: ''
		      //roleList: []
		     }
		  };
		}

	prepareBlankIndvData(compId){
		
		let data = {
		    id: '',
		    loginUserId: '',
		    phoneNumber: '',
		    firstName: '',
		    middleName: '',
		    lastName: '',
		    individualTypeStr: 'LEARNER',
		    status: '',
		    createdForCompany: compId,
		    addressList: [],
		    contactList: [],
		    compSubMapId:''
	  };
	  
	  this.prapareBlankContactList(data, "E-MAIL");
	  
	  return data;
	}
	
	prapareBlankContactList(dataObject, contactType){
		if("E-MAIL" === contactType){
			//for(let i=0; i<this.contactArray.length; i++){
		  	dataObject.contactList.push({
				contactType: 'E-MAIL',
				contactDetail: ''
			});
		  //}
		  if(dataObject.contactList.length > 0)
		  	dataObject.contactList[dataObject.contactList.length-1].contactType = "E-MAIL";
		} else if("PHONE" === contactType){
			//for(let i=0; i<this.contactArray.length; i++){
		  	dataObject.contactList.push({
				contactType: 'PHONE',
				contactDetail: ''
			});
		  //}
		  if(dataObject.contactList.length > 0)
		  	dataObject.contactList[dataObject.contactList.length-1].contactType = "PHONE";
		}
	}
	
    clearIndividualSystem() {
		if(this.extractedCompanyId > 0)
			this.resetData = this.prepareBlankIndvData(this.extractedCompanyId);
		else
    		this.resetData = this.prepareBlankIndvData(1);
		console.log("Clear::" + this.resetData	);
		
	  	this.trialIndvSignup.patchValue(this.resetData);
	  	return false;
	}
	getSingleContact(){
	  	return this.fb.group({
	      id: new FormControl(''),
	      contactType: new FormControl('', [Validators.required]),
	      contactDetail: new FormControl('')
	    });
  	}
	onRadioAction(value, actionInOut){
		this.showPurposeOfUseInfo = this.purposeOfUse;
		if(actionInOut === 'up'){
			this.showPurposeOfUseInfo = value;
		} else if(!this.purposeOfUse && actionInOut === 'in'){
			this.showPurposeOfUseInfo = value;
		} else if(!this.purposeOfUse && actionInOut === 'out'){
			this.showPurposeOfUseInfo = "";
		}
	}
}
